// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.DuplicateListing-module_body___lHzg0 {
  display: flex;
  flex-direction: column;
  height: min(620px, 74vh);
  width: 100%;
}

.theme--light .DuplicateListing-module_contextHeader___yoLej {
  border-bottom: 1px solid #dddddd;
}
.theme--dark .DuplicateListing-module_contextHeader___yoLej {
  border-bottom: 1px solid #2f2f2f;
}

.DuplicateListing-module_root___sl_4W {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
}

.DuplicateListing-module_sidebar___M86Db {
  width: 26rem;
  flex-shrink: 0;
  overflow-y: auto;
  padding: 1.6rem;
}
.theme--light .DuplicateListing-module_sidebar___M86Db {
  border-right: 1px solid #dddddd;
}
.theme--dark .DuplicateListing-module_sidebar___M86Db {
  border-right: 1px solid #2f2f2f;
}

.DuplicateListing-module_filters___p21c4 {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.DuplicateListing-module_fieldset___P3gFA {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin: 0;
  padding: 1.2rem;
  border-radius: 0.4rem;
}
.theme--light .DuplicateListing-module_fieldset___P3gFA {
  border: 1px solid #dddddd;
}
.theme--dark .DuplicateListing-module_fieldset___P3gFA {
  border: 1px solid #2f2f2f;
}

.DuplicateListing-module_legend___RJy4X {
  padding: 0 0.6rem;
  font-size: 1.3rem;
  font-weight: 600;
}
.theme--light .DuplicateListing-module_legend___RJy4X {
  color: #212121;
}
.theme--dark .DuplicateListing-module_legend___RJy4X {
  color: #f0f0f0;
}

.DuplicateListing-module_parkingRow___xceAj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  padding-top: 0.4rem;
}

.DuplicateListing-module_parkingLabel___c55ux {
  font-size: 1.4rem;
  font-weight: 600;
}
.theme--light .DuplicateListing-module_parkingLabel___c55ux {
  color: #212121;
}
.theme--dark .DuplicateListing-module_parkingLabel___c55ux {
  color: #f0f0f0;
}

.DuplicateListing-module_filterButtons___FgWD2 {
  display: flex;
  gap: 0.8rem;
}
.DuplicateListing-module_filterButtons___FgWD2 > * {
  flex: 1;
}

.DuplicateListing-module_tableArea___mgfSG {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.DuplicateListing-module_tableWrap___ecCbV {
  flex: 1;
  min-height: 0;
}

.DuplicateListing-module_tablePlaceholder___IAHoD {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 1.4rem;
  color: var(--textSecondary);
}

.DuplicateListing-module_tableFooter___L1dHV {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.6rem;
  font-size: 1.4rem;
  font-weight: 600;
}
.theme--light .DuplicateListing-module_tableFooter___L1dHV {
  border-top: 1px solid #dddddd;
  color: #212121;
}
.theme--dark .DuplicateListing-module_tableFooter___L1dHV {
  border-top: 1px solid #2f2f2f;
  color: #f0f0f0;
}

.DuplicateListing-module_divider___l2TFn {
  opacity: 0.4;
}

.DuplicateListing-module_footer___r6FSP {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.2rem;
}

.DuplicateListing-module_removeOld___KZxsW {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-right: 0.8rem;
  font-size: 1.4rem;
  cursor: pointer;
}
.theme--light .DuplicateListing-module_removeOld___KZxsW {
  color: #212121;
}
.theme--dark .DuplicateListing-module_removeOld___KZxsW {
  color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/duplicateListing/DuplicateListing.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;AAmBD;;AD+EE;EC7FA,gCAAA;AAkBF;AD2EE;EC7FA,gCAAA;AAqBF;;AAjBA;EACC,aAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;AAoBD;;AAjBA;EACC,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAoBD;AD0DE;EC3EA,+BAAA;AAoBF;ADuDE;EC3EA,+BAAA;AAuBF;;AAnBA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAsBD;;AAnBA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;AAsBD;ADqCE;ECxDA,yBAAA;AAsBF;ADkCE;ECxDA,yBAAA;AAyBF;;AArBA;EACC,iBAAA;EACA,iBAAA;EACA,gBAAA;AAwBD;ADyBE;EC9CA,cAAA;AAwBF;ADsBE;EC9CA,cAAA;AA2BF;;AAvBA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AA0BD;;AAvBA;EACC,iBAAA;EACA,gBAAA;AA0BD;ADME;EC7BA,cAAA;AA0BF;ADGE;EC7BA,cAAA;AA6BF;;AAzBA;EACC,aAAA;EACA,WAAA;AA4BD;AA1BC;EACC,OAAA;AA4BF;;AAxBA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA2BD;;AAxBA;EACC,OAAA;EACA,aAAA;AA2BD;;AAxBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;AA2BD;;AAxBA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AA2BD;ADtCE;ECcA,6BAAA;EACA,cAAA;AA2BF;AD1CE;ECcA,6BAAA;EACA,cAAA;AA+BF;;AA3BA;EACC,YAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AA8BD;ADlEE;ECuCA,cAAA;AA8BF;ADrEE;ECuCA,cAAA;AAiCF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  height: min(620px, 74vh);\n  width: 100%;\n}\n\n:global(.theme--light) .contextHeader {\n  border-bottom: 1px solid #dddddd;\n}\n:global(.theme--dark) .contextHeader {\n  border-bottom: 1px solid #2f2f2f;\n}\n\n.root {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n.sidebar {\n  width: 26rem;\n  flex-shrink: 0;\n  overflow-y: auto;\n  padding: 1.6rem;\n}\n:global(.theme--light) .sidebar {\n  border-right: 1px solid #dddddd;\n}\n:global(.theme--dark) .sidebar {\n  border-right: 1px solid #2f2f2f;\n}\n\n.filters {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n\n.fieldset {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  margin: 0;\n  padding: 1.2rem;\n  border-radius: 0.4rem;\n}\n:global(.theme--light) .fieldset {\n  border: 1px solid #dddddd;\n}\n:global(.theme--dark) .fieldset {\n  border: 1px solid #2f2f2f;\n}\n\n.legend {\n  padding: 0 0.6rem;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n:global(.theme--light) .legend {\n  color: #212121;\n}\n:global(.theme--dark) .legend {\n  color: #f0f0f0;\n}\n\n.parkingRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.8rem;\n  padding-top: 0.4rem;\n}\n\n.parkingLabel {\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n:global(.theme--light) .parkingLabel {\n  color: #212121;\n}\n:global(.theme--dark) .parkingLabel {\n  color: #f0f0f0;\n}\n\n.filterButtons {\n  display: flex;\n  gap: 0.8rem;\n}\n.filterButtons > * {\n  flex: 1;\n}\n\n.tableArea {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.tableWrap {\n  flex: 1;\n  min-height: 0;\n}\n\n.tablePlaceholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  font-size: 1.4rem;\n  color: var(--textSecondary);\n}\n\n.tableFooter {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 0.8rem 1.6rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n:global(.theme--light) .tableFooter {\n  border-top: 1px solid #dddddd;\n  color: #212121;\n}\n:global(.theme--dark) .tableFooter {\n  border-top: 1px solid #2f2f2f;\n  color: #f0f0f0;\n}\n\n.divider {\n  opacity: 0.4;\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1.2rem;\n}\n\n.removeOld {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  margin-right: 0.8rem;\n  font-size: 1.4rem;\n  cursor: pointer;\n}\n:global(.theme--light) .removeOld {\n  color: #212121;\n}\n:global(.theme--dark) .removeOld {\n  color: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `DuplicateListing-module_body___lHzg0`,
	"contextHeader": `DuplicateListing-module_contextHeader___yoLej`,
	"root": `DuplicateListing-module_root___sl_4W`,
	"sidebar": `DuplicateListing-module_sidebar___M86Db`,
	"filters": `DuplicateListing-module_filters___p21c4`,
	"fieldset": `DuplicateListing-module_fieldset___P3gFA`,
	"legend": `DuplicateListing-module_legend___RJy4X`,
	"parkingRow": `DuplicateListing-module_parkingRow___xceAj`,
	"parkingLabel": `DuplicateListing-module_parkingLabel___c55ux`,
	"filterButtons": `DuplicateListing-module_filterButtons___FgWD2`,
	"tableArea": `DuplicateListing-module_tableArea___mgfSG`,
	"tableWrap": `DuplicateListing-module_tableWrap___ecCbV`,
	"tablePlaceholder": `DuplicateListing-module_tablePlaceholder___IAHoD`,
	"tableFooter": `DuplicateListing-module_tableFooter___L1dHV`,
	"divider": `DuplicateListing-module_divider___l2TFn`,
	"footer": `DuplicateListing-module_footer___r6FSP`,
	"removeOld": `DuplicateListing-module_removeOld___KZxsW`
};
export default ___CSS_LOADER_EXPORT___;
